/* Top Corner Kids — scroll football.
   Scroll-linked: the ball's spot on its zigzag path is a direct
   function of scroll progress, so it travels WITH the visitor —
   no waiting at a dock and zipping to catch up. Between docks the
   path crests (sin arc) like a lobbed pass; rotation is cumulative
   distance along the path, signed by horizontal direction, and a
   light per-frame lerp gives it weight. Docks: under the hero CTA,
   then alternating left/right gutters per section.
   NOTE: init waits for window 'load' — at defer-time the stylesheets
   have not applied yet and every section measures ~0 tall. */
(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var SIZE = 46;
  var ARC = 60;
  var SPIN = 1.2;
  var EASE = 0.16;
  var tries = 0;

  function init() {
    var main = document.getElementById('MainContent');
    if (!main) return;
    var sections = Array.prototype.slice.call(main.querySelectorAll('.shopify-section')).filter(function (s) {
      return s.offsetHeight > 150;
    });
    if (sections.length < 2) {
      if (tries++ < 5) setTimeout(init, 800);
      return;
    }

    var ball = document.createElement('div');
    ball.id = 'tck-ball';
    ball.setAttribute('aria-hidden', 'true');
    var inner = document.createElement('div');
    inner.className = 'tck-ball-y';
    var idle = document.createElement('div');
    idle.className = 'tck-ball-idle';
    // Wikimedia "Soccerball" vector, seams thickened for 46px display
    idle.innerHTML =
      '<svg xmlns="http://www.w3.org/2000/svg" width="46" height="46" viewBox="-2500 -2500 5000 5000">' +
      '<g stroke="#000" stroke-width="70">' +
      '<circle fill="#fff" r="2376"/>' +
      '<path fill="none" d="m-1643-1716 155 158m-550 2364c231 231 538 195 826 202m-524-2040c-491 351-610 1064-592 1060m1216-1008c-51 373 84 783 364 1220m-107-2289c157-157 466-267 873-329m-528 4112c-50 132-37 315-8 510m62-3883c282 32 792 74 1196 303m-404 2644c310 173 649 247 1060 180m-340-2008c-242 334-534 645-872 936m1109-2119c-111-207-296-375-499-534m1146 1281c100 3 197 44 290 141m-438 495c158 297 181 718 204 1140"/>' +
      '</g>' +
      '<path fill="#000" d="m-1624-1700c243-153 498-303 856-424 141 117 253 307 372 492-288 275-562 544-724 756-274-25-410-2-740-60 3-244 84-499 236-764zm2904-40c271 248 537 498 724 788-55 262-105 553-180 704-234-35-536-125-820-200-138-357-231-625-340-924 210-156 417-296 616-368zm-3273 3033a2376 2376 0 0 1-378-1392l59-7c54 342 124 674 311 928-36 179-2 323 51 458zm1197-1125c365 60 717 120 1060 180 106 333 120 667 156 1000-263 218-625 287-944 420-372-240-523-508-736-768 122-281 257-561 464-832zm3013 678a2376 2376 0 0 1-925 1147l-116-5c84-127 114-297 118-488 232-111 464-463 696-772 86 30 159 72 227 118zm-2287 1527a2376 2376 0 0 1-993-251c199 74 367 143 542 83 53 75 176 134 451 168z"/>' +
      '</svg>';
    inner.appendChild(idle);
    ball.appendChild(inner);
    // Live inside the page container, not <body>: if the theme ever puts a
    // transform on the container (drawer menus do), content z-indexes get
    // trapped in its stacking context — the ball must be in there with them
    // or it paints on top of everything.
    var host = document.querySelector('.page-container') || document.body;
    if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
    host.appendChild(ball);
    var svg = idle.firstChild;

    function dock(idx) {
      var vw = document.documentElement.clientWidth;
      var sec = sections[idx];
      var top = sec.getBoundingClientRect().top + window.pageYOffset;
      if (idx === 0) {
        var btn = sec.querySelector('.hero__btn');
        if (btn) {
          var r = btn.getBoundingClientRect();
          return { x: r.left + r.width / 2 - SIZE / 2, y: r.bottom + window.pageYOffset + 14 };
        }
        return { x: vw / 2 - SIZE / 2, y: top + sec.offsetHeight - SIZE - 24 };
      }
      var gx = Math.max(16, (vw - 1200) / 2 - SIZE - 10);
      var x = idx % 2 === 1 ? gx : vw - gx - SIZE;
      return { x: x, y: top + Math.min(150, sec.offsetHeight * 0.2) };
    }

    function segRot(a, b) {
      var dx = b.x - a.x;
      var dy = b.y - a.y;
      var len = Math.sqrt(dx * dx + dy * dy);
      return (dx >= 0 ? 1 : -1) * (len / (Math.PI * SIZE)) * 360 * SPIN;
    }

    function pathState() {
      var vh = window.innerHeight;
      var line = window.pageYOffset + vh * 0.42;
      var docks = [];
      var tops = [];
      for (var k = 0; k < sections.length; k++) {
        docks.push(dock(k));
        tops.push(sections[k].getBoundingClientRect().top + window.pageYOffset);
      }
      // The ball stays parked on its dock while the visitor moves over a
      // section; it only travels inside a window around each boundary —
      // departing ~0.38 screens before the next section's top and landing
      // ~0.20 screens after it. In between it follows the scroll 1:1.
      var i = 0;
      var t = 0;
      // Late leave, late land: departure waits until the next section's top
      // is almost at the trigger line, and arrival completes once that
      // section has risen to the middle of the screen — so the ball is out
      // of the way while a section's content is being read.
      // prevArrive starts at the line's position when scrollY=0, so the
      // ball can never begin departing before the visitor has scrolled.
      var prevArrive = vh * 0.42 + 40;
      for (var j = 1; j < tops.length; j++) {
        var depart = Math.max(tops[j] - vh * 0.08, prevArrive + 40);
        var arrive = Math.max(tops[j] + vh * 0.32, depart + 120);
        prevArrive = arrive;
        if (line >= arrive) {
          i = j;
          continue;
        }
        if (line > depart) {
          i = j - 1;
          t = (line - depart) / (arrive - depart);
        }
        break;
      }
      t = t * t * (3 - 2 * t); // smoothstep: gentle leave and land
      var a = docks[i];
      var b = docks[Math.min(i + 1, docks.length - 1)];
      var rot = 0;
      for (var s = 0; s < i; s++) rot += segRot(docks[s], docks[s + 1]);
      rot += segRot(a, b) * t;
      return {
        x: a.x + (b.x - a.x) * t,
        y: a.y + (b.y - a.y) * t - Math.sin(t * Math.PI) * ARC,
        rot: rot
      };
    }

    var rx = null, ry = 0, rr = 0;

    function frame() {
      var p = pathState();
      if (rx === null) {
        rx = p.x; ry = p.y; rr = p.rot;
      } else {
        rx += (p.x - rx) * EASE;
        ry += (p.y - ry) * EASE;
        rr += (p.rot - rr) * EASE;
      }
      // pathState works in document coordinates; re-base onto the host
      // container the ball lives in.
      var hr = host.getBoundingClientRect();
      var ox = hr.left + window.pageXOffset;
      var oy = hr.top + window.pageYOffset;
      ball.style.transform = 'translateX(' + (rx - ox).toFixed(1) + 'px)';
      inner.style.transform = 'translateY(' + (ry - oy).toFixed(1) + 'px)';
      svg.style.transform = 'rotate(' + rr.toFixed(1) + 'deg)';
      requestAnimationFrame(frame);
    }

    requestAnimationFrame(frame);

    // exposed for automated checks
    window.__tckBall = { el: ball, inner: inner, svg: svg, sections: sections, dock: dock, pathState: pathState };
  }

  if (document.readyState === 'complete') {
    init();
  } else {
    window.addEventListener('load', init);
  }
})();
